module.exports = __webpack_public_path__ + "img/times-solid.2c5552a1.svg";